import { Alert } from "antd";
import React from "react";

// Shown in place of BottomActions (and the Text/Email InputArea) whenever
// the "All opportunity" option is selected in the thread's opp dropdown —
// replying isn't scoped to any single opportunity/root, so sending is
// disabled entirely. Shared between engagementActivity.js and
// browser-extension-v4.js so both surfaces stay in sync.
export const AllOpportunityReplyAlert = () => (
  <Alert
    className="m-2"
    type="warning"
    showIcon
    message={
      <span className="text-black-88 font-medium text-base leading-5">
        Reply is unavailable while viewing all opportunities
      </span>
    }
    description="Select a specific opportunity (e.g. Sales) above to continue the conversation."
  />
);

export default AllOpportunityReplyAlert;
